<template>
    <el-dialog :visible.sync="visible" title="新增合作单位" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :inline="true" :model="dataForm" label-width="150px">
            <el-row>
                <el-col span="12">
                    <el-form-item label="合作单位名称：">
                        <el-input v-model="dataForm.deptId" placeholder="请输入合作单位名称" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col span="12" class="btnRight">
                    <el-form-item class="btnList">
                        <el-button type="primary" @click="query()">查 询</el-button>
                        <el-button type="info" @click="reset()">重 置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="listBox">
            <el-table
                    ref="dataTable"
                    :data="selectList"
                    highlight-current-row
                    size="mini"
                    height="100%"
                    border
            >
                <el-table-column prop="subContractSerial" label="合作单位名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="subContractSerial" label="分类" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="subContractSerial" label="法人姓名" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="subContractSerial" label="注册地址" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </div>
        <el-footer class="container">
            <div class="btnMid">
                <el-button type="info" @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="submitBtn()">保 存</el-button>
            </div>
        </el-footer>
    </el-dialog>
</template>

<script>
    export default {
        name: "add-unit",
        data () {
            return {
                visible: false,
                dataForm: {
                    deptId: '',
                },
                selectList: [],
            }
        },
        methods:{
            init(){
                this.visible = true
            },
            submitBtn(){

            },
        }
    }
</script>

<style scoped lang="scss">
    /deep/.el-dialog{
        width: 70%;
    }
    .titleBox{
        display: flex;
        color: #101010;
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid #bbbbbb;
        margin: 20px;
        padding-bottom: 10px;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
    }
    .selectTitleTxt{
        margin-left: 55%;
        color: rgba(61, 61, 62, 100);
        font-size: 14px;
        margin-bottom: 12px;
    }
    .listBox{
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .noSelectList{
            width: 100%;
            height: 200px;
            border: 1px solid rgba(187, 187, 187, 100);
        }
    }
    .container{
        width: 100%;
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }
</style>
